export default __webpack_public_path__ + "static/media/DownlaodsIcon.e5a98b2c.svg";